module.exports = __webpack_public_path__ + "static/media/example-buttons.04ce64d7.png";